
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.171 11.211h.658l.846-.234v-.423l-.846-.188v-1.88h.329l.235-.234 6.013.376s.094-.047.094-.141a.956.956 0 00-.047-.235L7.782 7.077V4.822S7.735 3.79 7.5 3.79s-.282 1.033-.282 1.033v2.255L.547 8.252S.5 8.392.5 8.487c0 .094.094.14.094.14l6.013-.375.235.235h.33v1.879l-.846.188v.423l.845.234z"}})])
          )
        }
      }
    